import { createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { MaterialPalette } from '@nutrien/cxp-components';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      height: 'calc(100vh - 299px)',
      overflowY: 'auto',
      'scrollbar-width': 'none',
      '& #circularProgressGrid': {
        textAlign: 'center',
      },
      '& #inspectionApprovalDataCard': {
        padding: '8px',
      },
    },
    root1: {
      height: 'calc(100vh - 349px)',
      overflowY: 'auto',
      'scrollbar-width': 'none',
      '& #circularProgressGrid': {
        textAlign: 'center',
      },
      '& #inspectionApprovalDataCard': {
        padding: '8px',
      },
    },
    card: {
      padding: '12px',
    },
    searchBarOuterGrid: {
      alignItems: 'center',
      display: 'flex',
      height: (props: { isElectrical: boolean; portrait: boolean }) =>
        props.isElectrical && props.portrait ? 90 : 66,
    },
    xFeatherGrid: {
      alignSelf: 'center',
      marginLeft: '16px',
      display: 'flex',
    },
    searchBarDividerGrid: {
      marginLeft: 16,
      marginRight: 16,
      alignSelf: 'center',
      height: 32,
    },
    divider: {
      backgroundColor: 'rgba(255, 255, 255, 0.4)',
      width: '0.5px',
    },
    greenDot: {
      height: '5px',
      width: '5px',
      borderRadius: '50%',
      display: 'inline-block',
      backgroundColor: '#2AAB3F',
      margin: '0px 12px 4px 12px',
    },
    quickFilterText: {
      display: 'inline-block',
      textAlign: 'right',
    },

    accordion: {
      backgroundColor: 'rgba(255,255,255,0)',
      '& .MuiAccordionSummary-expandIcon': {
        color: 'rgb(42, 171, 63)',
      },
      '& .MuiAccordionSummary-content': {
        display: 'initial',
        marginTop: '0px ',
        marginBottom: '16px ',
      },
      '& .MuiAccordionDetails-root': {
        display: 'inherit',
      },
      '& #accordionlabel': {
        fontWeight: 700,
      },
    },
    accordianDivider: {
      width: '100%',
      marginBottom: '16px',
    },
    innerCard: {
      padding: 16,
    },
    pointer: {
      cursor: 'pointer',
      paddingRight: '20px',
    },
    messageGrid: {
      padding: '16px',
    },
    emptyBox: {
      verticalAlign: 'middle',
      marginRight: '18px',
    },
    divText: {
      display: 'inline-block',
      verticalAlign: 'middle',
    },
    quickFilterGrid: {
      alignSelf: 'center',
    },
    statusGrid: {
      paddingLeft: 8,
      alignSelf: 'center',
    },
    stampingGrid: {
      paddingLeft: 8,
      alignSelf: 'center',
      marginRight: 16,
    },
    searchTextField: {
      padding: '0px',
      cursor: 'pointer',
    },
    downloadIcon: {
      alignSelf: 'center',
      paddingRight: 4,
      cursor: 'pointer',
    },
    gridheading: {
      '& #inspectionListHeading': {
        fontSize: 30,
        fontWeight: 300,
      },
      '& #viewInspector': {
        fontSize: '14px',
        fontWeight: '600' as unknown as number,
        cursor: 'pointer',
        letterSpacing: '0.1px',
        width: 'fit-content',
      },
    },
    filterbutton: {
      '& .buttonWhenNotContained': {
        borderRadius: '27px',
        color: '#6CD9C7',
        height: 32,
        backgroundColor: 'rgba(39, 126, 126, 0.19)',
      },
      '& .buttonWhenContained': {
        borderRadius: '27px',
        color: MaterialPalette.common.white,
        height: 32,
        backgroundColor: '',
      },
    },
    inspectionTabDiv: {
      '& #inspectionTabCard': {
        marginBottom: 0,
      },
    },
    inspectionListDataDiv: {
      '& #inspectionListDataCard': {
        padding: '8px',
      },
    },
    diverderGrid: {
      alignSelf: 'center',
      height: 32,
    },
    iconVisible: {
      alignSelf: 'center',
      marginLeft: 16,
      display: 'flex',
      visibility: 'visible',
    },
    iconHidden: {
      alignSelf: 'center',
      marginLeft: 16,
      display: 'flex',
      visibility: 'hidden',
    },
    searchField: {
      alignSelf: 'center',
      marginLeft: 16,
      '& .searchTextbox': {
        backgroundColor: '#121212',
        width: 215,
      },
    },
    testSearchBoxPotrait: {
      backgroundColor: '#121212',
    },
  }),
);

export default useStyles;
